import React from 'react';
import PropTypes from 'prop-types';
import { TrackEvent } from '@bnnvara/analytics';
import * as S from './styled';
import Icon from '../Icon';

const CommentButton = ({ detailPageUrl }) => (
  <S.CommentButton
    href={`${detailPageUrl}#reageren`}
    target="_blank"
    rel="noopener noreferrer"
    onClick={TrackEvent('video-player-comment', 'click', 'link to comments')}
  >
    <Icon icon="comment" size="25" />
  </S.CommentButton>
);

CommentButton.propTypes = {
  detailPageUrl: PropTypes.string.isRequired,
};

export default CommentButton;
